export default __webpack_public_path__ + "static/media/higher_primary_logo_reversed.7cdafb1c.svg";